import firebase from 'firebase/app';
import { auth, firestore } from '@/firebaseConfig';
import PublisherService from '@/service/PublisherService.js';
import User from '../model/User';

export default class AuthenticationService {
  constructor(store) {
    // FIXME: invert this dependency
    this.store = store;
  }

  initialize() {
    const selfStore = this.store;

    auth.onAuthStateChanged(function (user) {
      if (user) {
        selfStore.commit('setCurrentUser', user);

        const publisherService = new PublisherService();
        publisherService
          .loadPublishersForUser(user.uid)
          .then((publishers) => {
            var currentPublisherValid = false;

            const currentPublisher = selfStore.state.currentPublisher;
            if (currentPublisher) {
              for (const publisher of publishers) {
                if (publisher.id == currentPublisher.id) {
                  currentPublisherValid = true;
                  break;
                }
              }
            }

            if (!currentPublisherValid && publishers && publishers.length > 0) {
              selfStore.commit('setCurrentPublisher', publishers[0]);
            }
          })
          .catch(() => {
            // Nothing to do
          });
      } else {
        selfStore.commit('setCurrentUser', null);
      }
    });
  }

  login(email, password) {
    const promise = new Promise((resolve, reject) => {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((user) => {
          this.store.commit('setCurrentUser', user.user);
          this.store.dispatch('fetchUserProfile');
          resolve(user.user);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  logout() {
    const promise = new Promise((resolve, reject) => {
      this.store.commit('setCurrentUser', null);
      auth
        .signOut()
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });

    return promise;
  }

  resetPassword(email, locale) {
    if (locale) {
      auth.languageCode = locale;
    }
    return auth.sendPasswordResetEmail(email);
  }

  getAuthenticatedUser() {
    return auth.user;
  }

  loadAuthenticatedUserProfile() {
    return new Promise((resolve, reject) => {
      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        firestore
          .collection('users')
          .doc(currentUser.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              resolve(new User(doc.data()));
            } else {
              resolve(null);
            }
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        reject(new Error('not authenticated'));
      }
    });
  }
}
